import { implementCustomExpressions } from '../__generated/implementation.js'
import type { PricingConfig } from '../data/pricing-config.js'

export const topWithWidthAndLengthExpressions = implementCustomExpressions({
  TopWithWidthAndLength: {
    $width: s => {
      return s.width
    },
    $length: s => {
      // TODO: Fix Dim indicators for tops with leaves
      // if (!s.$leafCenterVisible) {
      //   return s.length
      // }
      // return s.length + s.$leafCenterLength
      return s.length
    },
    $sizeDescription: s => {
      return `${Math.round(s.width)}" x ${Math.round(s.length)}"`
    },
    $price: s => {
      const p = s.$table.$pricingConfig as PricingConfig
      const pricing = p.tops[s.type] ?? { basePrice: 0, compoundingRate: 0.05, pricingStep: 6 }
      const sizing = s.$topDataMap[s.type].sizing
      const widthSteps = Math.trunc((Math.round(s.width) - sizing.width.default) / pricing.pricingStep)
      const lengthSteps = Math.trunc((Math.round(s.length) - sizing.length.default) / pricing.pricingStep)

      return Math.round(pricing.basePrice * Math.pow(1 + pricing.compoundingRate, widthSteps + lengthSteps))
    },
    $minWidth: s => {
      return s.$topDataMap[s.type].sizing.width.min
    },
    $maxWidth: s => {
      return s.$topDataMap[s.type].sizing.width.max
    },
    $minLength: s => {
      return s.$topDataMap[s.type].sizing.length.min
    },
    $maxLength: s => {
      return s.$topDataMap[s.type].sizing.length.max
    },
    $defaultWidth: s => s.$topDataMap[s.type].sizing.width.default,
    $defaultLength: s => s.$topDataMap[s.type].sizing.length.default,
    $distance: s => {
      return s.$leafCenterVisible ? s.$leafLength * s.leafAmount : 0
    },
    $distanceScaleZero: () => {
      // scaleZero = 0 means no separation (shape key at 0)
      return 0
    },
    $distanceScaleOne: s => {
      // scaleOne = scaleDelta means full separation range
      return s.$topDataMap[s.type].sizing.distance.scaleDelta
    },
    $leafBevel: s => {
      // When leaf is enabled, set to scaleOne to show bevel edge in the middle
      return s.$leafCenterVisible ? 0.05 : 0
    },
  },
})
